<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div
      style="background: url('/static/images/saike/bg.png');background-repeat: no-repeat;background-size:inherit;height: 100%;min-height: 100vh;">

      <div style="position: absolute;top:5%;text-align: center;" >
          <img src="/static/images/saike/logo.png" width="40%"/>
      </div>
      <div style="position: absolute;top:18%;text-align: center;" >
          <img src="/static/images/saike/saikesi.png" width="70%"/>
      </div> 
      <div style="position: absolute;top:27%;text-align: center;" >
          <img src="/static/images/saike/jiasai.png" width="35%"/>
      </div>
      <div style="position: absolute;top:36%;text-align: center;" >
          <img src="/static/images/saike/text.png" width="60%"/>
      </div>
      <div v-if="antiInitShow">
        <div
          style="position: absolute;bottom: 0%;width: 100%;height: 54%;border: 0px solid;background-color: rgba(0, 0, 0, 0.8);display: flex;flex-direction: column;">
          <div
            style="width: 100%;color: white;margin-top: 10px;display: flex;justify-content:center;align-items: center;text-align: center;font-size: 23px;">
            塞克斯防伪验证系统
          </div>
          <div style="height: 100%;overflow-y:scroll;">
            <div style="width: 100%;margin-top: 25px;text-align: center ;">
              <input type="text" v-model="antiCode" style="width: 75%;height: 40px;border-radius: 10px;border: 0px;padding-left: 5%;"
                placeholder="  请输入16位防伪码进行查询" @input="handleInput" />
            </div>
            <div
              style="width: 100%;margin-top: 15px;text-align: center ;display: flex;justify-content:center;align-items: center;">
              <div @click="queryAnti"
                style="width: 75%;height: 40px;background-color: rgb(40, 133, 244);font-weight: bold;color: white;border-radius: 10px;border: 0px;display: flex;justify-content:center;align-items: center;">
                确认
              </div>
            </div>



            <div
              style="width: 100%;margin-top: 15px;text-align: center ;display: flex;justify-content:center;align-items: center;">

              <div
                style="width: 75%;height: 140px;background-color: rgba(255, 255, 255,0.6);font-weight: bold;color: white;border-radius: 10px;border: 0px;display: flex;justify-content:center;align-items: center;">
                <img src="/static/images/saike/barcode1.png"
                  style="width: 100px; height: 100px;" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img src="/static/images/saike/barcode2.png" style="width: 100px; height: 100px;" />
              </div>
            </div>
          </div>
        </div>
      </div>





      <div v-if="antiResultShow">
        <div
          style="position: absolute;bottom: 0%;width: 100%;height: 54%;border: 0px solid;background-color: rgba(0, 0, 0, 0.8);display: flex;flex-direction: column;">
          <div
            style="width: 100%;color: rgb(39, 128, 242);margin-top: 10px;display: flex;justify-content:center;align-items: center;text-align: center;font-size: 23px;">
            塞克斯防伪验证系统
          </div>
          <div style="height: 100%;overflow-y:scroll;">
            <div style="width: 100%;margin-top: 25px;text-align: left ;color: white;padding: 0px 10% 0px 10%;word-wrap: break-word;overflow-wrap: break-word;font-size: 15px;line-height: 1.5;">
              您查询的数码为：{{ this.antiCode }}<br/><br/><br/>
              <span v-html="antiResult"></span>
            </div>  
          </div>
        </div>
      </div>



    </div>

    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>

<script>
import { getAntiData } from '../../api/api'

export default {
  data() {
    return {
      isShow: false,
      antiInitShow: true,
      antiResultShow: false,
      antiResult:"",
      antiCode: "",
    }
  },
  methods: {
    handleInput(){
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    queryAnti() {
      if (this.antiCode == "") {
        alert("请输入16位防伪码进行查询验证")
        return;
      }
      this.getResult();

    },
    getResult() {
      this.isShow = true
      const code = this.antiCode.replace(/\s+/g, '');
      const params = this.$route.query;
      const eno = params.eno;
      if(eno==null ||eno==undefined){
        this.isShow = false
        alert("请使用正确入口地址进行查询")
        return;
      }
      getAntiData(code,eno).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.isShow = false
          this.antiInitShow = true
          this.antiResultShow = false
          alert(data.message);
        } else {
          if (data.code === "300102") {
            this.antiResult="此防伪数码被查询"+data.data.queryCount+"次，首次查询时间是"+data.data.firstQueryTime+"，请确认首次查询是否为本人，否则警防假冒!"
          } else if (data.code == "300101") {
            this.antiResult="加塞专用，塞克斯巧克粉<br/>您选购的塞克斯巧克粉经查询为正品<br/>独牙战略投资品牌、中式九球系列大赛指定巧克粉品牌"
          }else if(data.code == "300106"){
            this.antiResult="此防伪数码不存在，谨防假冒，或重新核对后重新输入查询。谢谢!"
          }
          this.isShow = false
          this.antiInitShow = false
          this.antiResultShow = true
        }
        this.isShow = false
      }).catch(err => {
        this.isShow = false
        alert("查询异常，请联系管理员")
      }
      )

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SaiKe/Index.vue